module.exports = {"TXTWCL_Stake":{"id":"TXTWCL_Stake","defaultMessage":"Indsats","track":"Stake"}}